// Słownik pól prezlecenia wyciąganych przez AI z maila (W3). Wzorowany na
// fieldDictionary z panelu driver-documents w FreightFusion.

export type PreOrderFieldSpec = { required: string[]; optional: string[] };

// Pola, których pipeline W3 wymaga dla prezlecenia (zasada: nieczytelne = puste).
export const PRE_ORDER_FIELDS: PreOrderFieldSpec = {
  required: [
    'klient',
    'adres_zaladunku',
    'adres_rozladunku',
    'data_zaladunku',
    'data_rozladunku',
    'towar',
    'waga',
  ],
  optional: ['cena', 'palety', 'uwagi'],
};

export const FIELD_LABELS: Record<string, string> = {
  klient: 'Klient',
  adres_zaladunku: 'Adres załadunku',
  adres_rozladunku: 'Adres rozładunku',
  data_zaladunku: 'Data załadunku',
  data_rozladunku: 'Data rozładunku',
  towar: 'Towar',
  waga: 'Waga',
  cena: 'Cena',
  palety: 'Palety',
  uwagi: 'Uwagi',
};

export interface ExtractedField {
  value?: unknown;
  present?: boolean;
  confidence?: number;
  reason?: string;
}

// Rozpakowuje kopertę { fields: {...}, missing_mandatory }.
export const extractedFieldsMap = (
  extractedFields: Record<string, unknown> | null | undefined,
): Record<string, ExtractedField> | null => {
  const nested = (extractedFields as { fields?: unknown } | null | undefined)?.fields;
  if (nested && typeof nested === 'object') return nested as Record<string, ExtractedField>;
  return null;
};

export interface FieldStatus {
  present: boolean;
  value: string | null;
  confidence: number | null;
  reason: string | null;
}

export const fieldStatus = (
  field: string,
  extractedFields: Record<string, unknown> | null | undefined,
): FieldStatus => {
  const entry = extractedFieldsMap(extractedFields)?.[field];
  if (!entry) return { present: false, value: null, confidence: null, reason: null };
  const hasValue = entry.value != null && String(entry.value).trim() !== '';
  return {
    present: entry.present === true && hasValue,
    value: hasValue ? String(entry.value) : null,
    confidence: entry.confidence ?? null,
    reason: entry.reason ?? null,
  };
};

export const countReadFields = (
  extractedFields: Record<string, unknown> | null | undefined,
): { present: number; total: number } => {
  const present = PRE_ORDER_FIELDS.required.filter((f) => fieldStatus(f, extractedFields).present).length;
  return { present, total: PRE_ORDER_FIELDS.required.length };
};
